var isFunction=function(a){return"function"==typeof a};export default isFunction;